import { Button } from "./Button";
import { Column } from "./Column";
import { GridContainer } from "./GridContainer";
import { ContentRestrictive } from "./ContentRestrictive";
import { Heading } from "./Heading";
import { Hr } from "./Hr";
import { Icon } from "./Icon";
import { Iframe } from "./Iframe";
import { Image } from "./Image";
import { LayoutContainer } from "./LayoutContainer";
import { Paragraph } from "./Paragraph";
import { CardFilter } from "./CardFilter";
import { Row } from "./Row";
import { Section } from "./Section";
import { Video } from "./Video";
import {
    Footer,
    Header,
    CardList,
    Card,
    CardSlider,
    EventSlider
} from "./widgets";
import { Accordion } from "./Accordion";
import { AnnouncementList } from "./widgets/AnnouncementList";
import { BookNow } from "./widgets/BookNow";
import { ContactUs } from "./widgets";
import { Container, ContainerEntry } from "app/library/layout-builder";
import { ContentGrid } from "./widgets/ContentGrid";
import { CorporateTimeline } from "./widgets/CorporateTimeline";
import { Corporation } from "./widgets";
import { CultureRoad } from "./widgets/CultureRoad";
import { DigitalScene } from "./widgets";
import { EventCardList } from "./widgets/EventCardList";
import { ArchiveEventCardList } from "./widgets/ArchiveEventCardList";
import { EventCardSlider } from "./widgets/EventCardSlider";
import { EventDetail } from "./widgets";
import { EventPage } from "./widgets/EventPage";
import { FullCardList } from "./widgets/FullCardList";
import { GoogleMaps } from "./widgets/GoogleMaps";
import { Hero } from "./widgets/Hero";
import { HeroSlider } from "./widgets/HeroSlider";
import { Html } from "./Html";
import { IconList } from "./IconList";
import { Instagram } from "./widgets/Instagram";
import { LayoutScreen } from "./LayoutScreen";
import { Membership } from "./widgets";
import { MobileInstruments } from "./widgets";
import { MobileInstrumentsCategories } from "./widgets/MobileInstrumentsCategories";
import { MobileInstrumentsList } from "./widgets";
import { MultipleAccordionWithAudio } from "./widgets/MultipleAccordionWithAudio";
import { MusicPlatformAudio } from "./widgets/MusicPlatformAudio";
import { PageTitle } from "./widgets";
import { PhotoGallery } from "./PhotoGallery";
import { PhotoGalleryFull } from "./PhotoGalleryFull";
import { PopupAnnouncement } from "./widgets/PopupAnnouncement";
import { PureContent } from "./PureContent";
import { Redirection } from "./Redirection";
import { Scrollbar } from "./Scrollbar";
import { Slideshow } from "./Slideshow";
import { SmartInfoboxList } from "./widgets/SmartInfoboxList";
import { SocialMediaSlider } from "./widgets/SocialMediaSlider";
import { Style } from "./Style";
import { Subscribe } from "./widgets";
import { SubscribeOut } from "./widgets";
import { ThreedWithAudio } from "./widgets/ThreedWithAudio";
import { VenueDetail } from "./widgets";
import { VenueRental } from "./widgets";
import { VideoSlider } from "./widgets/VideoSlider";
import { SettlementPlan } from "./widgets/SettlementPlan";
import { VenueRentalAccordion } from "./widgets/VenueRentalAccordion";
import { CorporateButtons } from "./widgets/CorporateButtons";
import { Playlist } from "./widgets/Playlist";
import { SignIn } from "./widgets/SignIn";
import { SignUp } from "./widgets/SignUp";
import { ForgotPassword } from "./widgets/ForgotPassword";
import { LibraryAppointment } from "./widgets/LibraryAppointment";
import { AccountProfile } from "./widgets/AccountProfile";
import { AccountAppointments } from "./widgets/AccountAppointments";
import { AccountEmail } from "./widgets/AccountEmail";
import { AccountPhone } from "./widgets/AccountPhone";
import { AccountPassword } from "./widgets/AccountPassword";
import { AccountSidebar } from "./widgets/AccountSidebar";
import { Authentication } from "./widgets/Authentication";
import { QrCode } from "./widgets/QrCode";
import { ImagePopup } from "./widgets/ImagePopup";
import { ArtChildrenEventList } from "./widgets/ArtChildrenEventList";
import { ArtChildrenGallery } from "./widgets/ArtChildrenGallery";
import { MusicRecordingStudioForm } from "./widgets/MusicRecordingStudioForm";
import { Competition } from "./widgets/Competition";
import { CultureRoadV2 } from "./widgets/CultureRoadV2";
import { EventCalendar } from "./widgets/EventCalendar"
import { List } from "./List";

export const container = new Container([
    ContainerEntry.buildFromComponent(Accordion),
    ContainerEntry.buildFromComponent(AnnouncementList),
    ContainerEntry.buildFromComponent(BookNow),
    ContainerEntry.buildFromComponent(Button),
    ContainerEntry.buildFromComponent(Card),
    ContainerEntry.buildFromComponent(CardFilter),
    ContainerEntry.buildFromComponent(CardList),
    ContainerEntry.buildFromComponent(CardSlider),
    ContainerEntry.buildFromComponent(Column),
    ContainerEntry.buildFromComponent(ContactUs),
    ContainerEntry.buildFromComponent(ContentGrid),
    ContainerEntry.buildFromComponent(ContentRestrictive),
    ContainerEntry.buildFromComponent(CorporateButtons),
    ContainerEntry.buildFromComponent(CorporateTimeline),
    ContainerEntry.buildFromComponent(Corporation),
    ContainerEntry.buildFromComponent(CultureRoad),
    ContainerEntry.buildFromComponent(DigitalScene),
    ContainerEntry.buildFromComponent(EventCardList),
    ContainerEntry.buildFromComponent(ArchiveEventCardList),
    ContainerEntry.buildFromComponent(EventCardSlider),
    ContainerEntry.buildFromComponent(EventDetail),
    ContainerEntry.buildFromComponent(EventPage),
    ContainerEntry.buildFromComponent(EventSlider),
    ContainerEntry.buildFromComponent(Footer),
    ContainerEntry.buildFromComponent(FullCardList),
    ContainerEntry.buildFromComponent(GoogleMaps),
    ContainerEntry.buildFromComponent(GridContainer),
    ContainerEntry.buildFromComponent(Header),
    ContainerEntry.buildFromComponent(Heading),
    ContainerEntry.buildFromComponent(Hero),
    ContainerEntry.buildFromComponent(HeroSlider),
    ContainerEntry.buildFromComponent(Hr),
    ContainerEntry.buildFromComponent(Html),
    ContainerEntry.buildFromComponent(Icon),
    ContainerEntry.buildFromComponent(IconList),
    ContainerEntry.buildFromComponent(Iframe),
    ContainerEntry.buildFromComponent(Image),
    ContainerEntry.buildFromComponent(Instagram),
    ContainerEntry.buildFromComponent(LayoutContainer),
    ContainerEntry.buildFromComponent(LayoutScreen),
    ContainerEntry.buildFromComponent(Membership),
    ContainerEntry.buildFromComponent(MobileInstruments),
    ContainerEntry.buildFromComponent(MobileInstrumentsCategories),
    ContainerEntry.buildFromComponent(MobileInstrumentsList),
    ContainerEntry.buildFromComponent(MultipleAccordionWithAudio),
    ContainerEntry.buildFromComponent(MusicPlatformAudio),
    ContainerEntry.buildFromComponent(PageTitle),
    ContainerEntry.buildFromComponent(Paragraph),
    ContainerEntry.buildFromComponent(PhotoGallery),
    ContainerEntry.buildFromComponent(PhotoGalleryFull),
    ContainerEntry.buildFromComponent(Playlist),
    ContainerEntry.buildFromComponent(PopupAnnouncement),
    ContainerEntry.buildFromComponent(PureContent),
    ContainerEntry.buildFromComponent(Redirection),
    ContainerEntry.buildFromComponent(Row),
    ContainerEntry.buildFromComponent(Scrollbar),
    ContainerEntry.buildFromComponent(Section),
    ContainerEntry.buildFromComponent(SettlementPlan),
    ContainerEntry.buildFromComponent(Slideshow),
    ContainerEntry.buildFromComponent(SmartInfoboxList),
    ContainerEntry.buildFromComponent(SocialMediaSlider),
    ContainerEntry.buildFromComponent(Style),
    ContainerEntry.buildFromComponent(Subscribe),
    ContainerEntry.buildFromComponent(SubscribeOut),
    ContainerEntry.buildFromComponent(ThreedWithAudio),
    ContainerEntry.buildFromComponent(VenueDetail),
    ContainerEntry.buildFromComponent(VenueRental),
    ContainerEntry.buildFromComponent(VenueRentalAccordion),
    ContainerEntry.buildFromComponent(Video),
    ContainerEntry.buildFromComponent(VideoSlider),
    ContainerEntry.buildFromComponent(SignIn),
    ContainerEntry.buildFromComponent(SignUp),
    ContainerEntry.buildFromComponent(ForgotPassword),
    ContainerEntry.buildFromComponent(LibraryAppointment),
    ContainerEntry.buildFromComponent(AccountProfile),
    ContainerEntry.buildFromComponent(AccountAppointments),
    ContainerEntry.buildFromComponent(AccountEmail),
    ContainerEntry.buildFromComponent(AccountPhone),
    ContainerEntry.buildFromComponent(AccountPassword),
    ContainerEntry.buildFromComponent(AccountSidebar),
    ContainerEntry.buildFromComponent(Authentication),
    ContainerEntry.buildFromComponent(QrCode),
    ContainerEntry.buildFromComponent(ImagePopup),
    ContainerEntry.buildFromComponent(ArtChildrenEventList),
    ContainerEntry.buildFromComponent(ArtChildrenGallery),
    ContainerEntry.buildFromComponent(Competition),
    ContainerEntry.buildFromComponent(MusicRecordingStudioForm),
    ContainerEntry.buildFromComponent(Competition),
    ContainerEntry.buildFromComponent(CultureRoadV2),
    ContainerEntry.buildFromComponent(EventCalendar),
    ContainerEntry.buildFromComponent(List),
]);
